import { render } from "./CompanyDisabled.vue?vue&type=template&id=1884f874"
import script from "./CompanyDisabled.vue?vue&type=script&lang=js"
export * from "./CompanyDisabled.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./CompanyDisabled.vue?vue&type=style&index=0&id=1884f874&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script